// @flow

import { group, getGraph } from "./graph";

export default function getVersion(file: string) {
  return getGraph(
    `/groups/${group}/drive/items/${file}/workbook/names/Version/range?$select=values`
  ).then(res => res.values[0][0]);
}



// WEBPACK FOOTER //
// ./src/model/getVersion.js